<template>
<div class="containers">
    <CAlert
        v-if="success == true"
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <CAlert
        v-else
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:red;border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
    </CAlert>
    <div class="search-area">
        <CRow class="no-gutters">
            <CCol style="padding-right:4px" sm="10">
                <div class="autocomplete">
                    <input type="text"
                            class="form-control"
                            @click="toggleVisiblePegawai()"
                            @blur="toggleCloseVisiblePegawai()"
                            v-model="queryPegawai"
                            v-text="selectedItemPegawai ? selectedItemPegawai['text'] : ''"
                            @keydown.up="upPegawai"
                            @keydown.down="downPegawai"
                            @keydown.enter="selectItemPegawai"
                            placeholder="Pilih Pegawai"
                    >
                    <div class="popovers" v-show="visiblePegawai">
                        <div class="options" v-if="matchesPegawai.length != 0 && queryPegawai.length != 0" ref="optionsList">
                            <ul>
                            <li v-for="(match, index) in matchesPegawai"
                                :key="index"
                                :class="{ 'selected': (selectedPegawai == index)}"
                                @click="itemClickedPegawai(index)"
                                v-text="match['text']"></li>
                            </ul>
                        </div>
                        <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length != 0">
                            Data Tidak Ditemukan
                        </div>
                        <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length == 0">
                            Start Typing...
                        </div>
                    </div>
                </div>
            </CCol>
            <CCol style="padding-left:6px" sm="2">
                <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
            </CCol>
        </CRow>
    </div>
    <div class="sticky1">
        <CRow>
            <CCol sm="6"></CCol>
            <CCol sm="6">
                <span style="float:right">
                    <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                    <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                    <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                </span>
                <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                <img class="mr-5 mt-1" style="float:right" :src="moreIcon" width="20px" height="20px"/>
                <img class="mr-5 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="cursor:pointer;float:right"/>
            </CCol>
        </CRow>
    </div>
    <Tables @sort="sorting" @edit="editData" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
    <CModal
        size="lg"
        :centered="true"
        color="white"
        :show.sync="editModal"
        :closeOnBackdrop="false"
        >
        <template #header-wrapper>
            <div class="headers-modal">
                <CRow>
                    <CCol sm="10">
                        <div>Reset Device</div>
                    </CCol>
                    <CCol sm="2" class="text-right">
                        <img :src="closeIcon" @click="editModal = false, deviceAlasan = ''" style="cursor:pointer" width="20px" height="20px"/>
                    </CCol>
                </CRow>
            </div>
        </template>
        <template #body-wrapper>
            <div style="padding-right:20px;padding-left:20px">
                <CRow>
                    <CCol sm="3">
                        Nama Device
                    </CCol>
                    <CCol sm="9">
                        : {{namaDevice}}
                    </CCol>
                </CRow>
                <CRow class="mt-2">
                    <CCol sm="3">
                        Tipe Device
                    </CCol>
                    <CCol sm="9">
                        : {{tipeDevice}}
                    </CCol>
                </CRow>
                <CRow class="mt-2">
                    <CCol sm="3">
                        Device ID
                    </CCol>
                    <CCol sm="9">
                        : {{deviceId}}
                    </CCol>
                </CRow>
                <CRow class="mt-2">
                    <CCol sm="3">
                        Alasan
                    </CCol>
                    <CCol sm="9">
                        <textarea class="form-control w-100" v-model="deviceAlasan" placeholder="Tulis Alasan"/>
                    </CCol>
                </CRow>
            </div>
            <CRow class="mt-4" style="padding-bottom:40px;padding-left:20px;padding-right:20px">
                <CCol class="text-right" sm="12">
                    <CButton @click="editModal = false, deviceAlasan = ''" class="modal-buttons modal-button-cancel mr-1">Kembali</CButton>
                    <CButton @click="onSubmitDevice()" v-if="deviceAlasan != ''" class="modal-buttons modal-button-simpan ml-1">Reset</CButton>
                    <CButton disabled v-else class="modal-buttons modal-button-simpan ml-1">Reset</CButton>
                </CCol>
            </CRow>
        </template>
        <template #footer-wrapper><span></span></template>
    </CModal>
</div>
</template>

<script>
import Tables from '../../../component/tableDevice'
import {DataApi} from "../../../service/DataApi";
export default {
    components: {
        Tables,
    },
    data() {
        return {
            editModal: false,

            // data search pegawai
            dataPegawai: [],
            titlePegawai:"Pilih Pegawai",
            selectedItemPegawai: null,
            selectedPegawai: 0,
            queryPegawai: '',
            visiblePegawai: false,
            idPeg: '',

            goArea: true,
            loading: false,
            success: '',
            alertMess: '',
            currentAlertCounter: 0,

            // datas
            refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
            closeIcon: require('../../../assets/menu/icon_close.svg'),
            moreIcon: require('../../../assets/menu/icon_more.svg'),
            dataTh: ['Nama Device', 'Device OS', 'Device ID', 'Action'],
            dataTd: [0, 1, 2, 'action'],
            styleTable: ['300px', '300px','300px','200px',],
            classReload: 'reloadOff',
            datas: [],
            arrData: [],
            namaDevice: '',
            tipeDevice: '',
            deviceId: '',
            deviceAlasan: '',

            // paging
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,

            // error
            errorMessage: '',            
        }
    },
    computed: {
        matchesPegawai() {
            if (this.queryPegawai == '') {
                return [];
            }
            return this.dataPegawai.filter((item) => item['text'].toLowerCase().includes(this.queryPegawai.toLowerCase()))
        },
    },
    watch: {
        page() {
            this.getData()
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        queryPegawai() {
            this.page = 1
            this.getDataPegawai()
        },
    },
    methods: {
        /**
         * SEARCH PEGAWAI
         */
        getDataPegawai() {
            let payload = {
                bidang: '',
                jabatan: '',
                limit: 10,
                nama: this.queryPegawai,
                pageIn: 1,
                pegawaiId: '',
                tipePegawai: ''
            }
            DataApi.post("pegawai/get", payload)
            .then(res => {
                this.dataPegawai = []
                let response = res.data
                let tempData = response.data.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].idPegawai,
                        text: tempData[i].nama + ' - ' + tempData[i].nik
                    }
                    this.dataPegawai.push(onPush)
                }
            })
        },
        toggleVisiblePegawai() {
            this.visiblePegawai = true;
        },
        hidePegawai() {
            this.visiblePegawai = false;
        },
        toggleCloseVisiblePegawai() {
            setTimeout(this.hidePegawai, 1000);
        },
        itemClickedPegawai(index) {
            this.selectedPegawai = index;
            this.selectItemPegawai();
        },
        selectItemPegawai() {
            if (!this.matchesPegawai.length) {
            return;
            }
            this.selectedItemPegawai = this.matchesPegawai[this.selectedPegawai];
            this.visiblePegawai = false;
            this.queryPegawai = this.selectedItemPegawai.text
            this.idPeg = this.selectedItemPegawai.value
            if (this.shouldReset) {
            this.queryPegawai = '';
            this.selectedPegawai = 0;
            }
        },
        upPegawai() {
            if (this.selectedPegawai == 0) {
            return;
            }
            this.selectedPegawai -= 1;
            this.scrollToItemPegawai();
        },
        downPegawai() {
            if (this.selectedPegawai >= this.matchesPegawai.length - 1) {
            return;
            }
            this.selectedPegawai += 1;
            this.scrollToItemPegawai();
        },
        scrollToItemPegawai() {
            this.$refs.optionsList.scrollTop = this.selectedPegawai * this.itemHeight;
        },

        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.nama.toLowerCase() < b.nama.toLowerCase()) {
                        return -1
                    }
                    if (a.nama.toLowerCase() > b.nama.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.nik.toLowerCase() < b.nik.toLowerCase()) {
                        return -1
                    }
                    if (a.nik.toLowerCase() > b.nik.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 2) {
                function compare(a,b) {
                    if (a.polaAbsensi.toLowerCase() < b.polaAbsensi.toLowerCase()) {
                        return -1
                    }
                    if (a.polaAbsensi.toLowerCase() > b.polaAbsensi.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 3) {
                function compare(a,b) {
                    if (a.wfh.toLowerCase() < b.wfh.toLowerCase()) {
                        return -1
                    }
                    if (a.wfh.toLowerCase() > b.wfh.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 4) {
                function compare(a,b) {
                    if (a.wfo.toLowerCase() < b.wfo.toLowerCase()) {
                        return -1
                    }
                    if (a.wfo.toLowerCase() > b.wfo.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 5) {
                function compare(a,b) {
                    if (a.mangkir.toLowerCase() < b.mangkir.toLowerCase()) {
                        return -1
                    }
                    if (a.mangkir.toLowerCase() > b.mangkir.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 6) {
                function compare(a,b) {
                    if (a.dinas.toLowerCase() < b.dinas.toLowerCase()) {
                        return -1
                    }
                    if (a.dinas.toLowerCase() > b.dinas.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 7) {
                function compare(a,b) {
                    if (a.cuti.toLowerCase() < b.cuti.toLowerCase()) {
                        return -1
                    }
                    if (a.cuti.toLowerCase() > b.cuti.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 8) {
                function compare(a,b) {
                    if (a.sakit.toLowerCase() < b.sakit.toLowerCase()) {
                        return -1
                    }
                    if (a.sakit.toLowerCase() > b.sakit.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 9) {
                function compare(a,b) {
                    if (a.ijin.toLowerCase() < b.ijin.toLowerCase()) {
                        return -1
                    }
                    if (a.ijin.toLowerCase() > b.ijin.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 10) {
                function compare(a,b) {
                    if (a.nsi.toLowerCase() < b.nsi.toLowerCase()) {
                        return -1
                    }
                    if (a.nsi.toLowerCase() > b.nsi.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 11) {
                function compare(a,b) {
                    if (a.nso.toLowerCase() < b.nso.toLowerCase()) {
                        return -1
                    }
                    if (a.nso.toLowerCase() > b.nso.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 12) {
                function compare(a,b) {
                    if (a.telat.toLowerCase() < b.telat.toLowerCase()) {
                        return -1
                    }
                    if (a.telat.toLowerCase() > b.telat.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 13) {
                function compare(a,b) {
                    if (a.cepet.toLowerCase() < b.cepet.toLowerCase()) {
                        return -1
                    }
                    if (a.cepet.toLowerCase() > b.cepet.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 14) {
                function compare(a,b) {
                    if (a.lembur.toLowerCase() < b.lembur.toLowerCase()) {
                        return -1
                    }
                    if (a.lembur.toLowerCase() > b.lembur.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 15) {
                function compare(a,b) {
                    if (a.hariKerjaKalender.toLowerCase() < b.hariKerjaKalender.toLowerCase()) {
                        return -1
                    }
                    if (a.hariKerjaKalender.toLowerCase() > b.hariKerjaKalender.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 16) {
                function compare(a,b) {
                    if (a.hariKerjaPegawai.toLowerCase() < b.hariKerjaPegawai.toLowerCase()) {
                        return -1
                    }
                    if (a.hariKerjaPegawai.toLowerCase() > b.hariKerjaPegawai.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        getData() {
            this.$store.state.loadingScreen = true
            let payload = {
                pegawaiId: this.idPeg
            }
            DataApi.post("pegawai/get/device/backoffice", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    let temp = response.data.Data2
                    this.arrData = response.data.Data1
                    if(temp == "You have no data to show") {
                        this.errorMessage = temp
                        this.datas = []
                    } else {
                        this.datas = []
                        let arr = temp.split("@@")
                        var i = 0
                        for(i=0;i<arr.length-1;i++) {
                            let onPush = arr[i].split("##")
                            var j = 0 
                            for(j=0;j<onPush.length;j++) {
                                if(onPush[j] == '' || onPush[j] == 'null') {
                                    onPush[j] = ''
                                }
                            }
                            this.datas.push(onPush)
                        }
                    }
                    this.totalRow = this.datas.length
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.errorMessage = response.data.Data2
                }
                this.$store.state.loadingScreen = false
            })
        },
        findData() {
            this.getData()
        },
        reload() {
            this.queryPegawai = ''
            this.idPeg = ''
            this.page = 1
            this.getData()
            this.getDataPegawai()

            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },

        editData(val) {
            this.namaDevice = this.datas[val][0]
            this.tipeDevice = this.datas[val][2]
            this.deviceId = this.datas[val][3]
            this.editModal = true
        },
        onSubmitDevice() {
            let data = this.arrData
            let arr = data.split("##")
            var i = 0
            for(i=0;i<arr.length;i++) {
                if(arr[i] == '' || arr[i] == 'null') {
                    arr[i] = ''
                }
            }
            let payload = {
                alasan: this.deviceAlasan,
                idAtasan: arr[5],
                idDevice: this.deviceId,
                idPegawai: arr[0]
            }
            DataApi.post("pegawai/delete/device/backoffice", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1.split("@@")[0] == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data1.split("@@")[1]
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.deviceAlasan = ''
                this.loading = false
                this.currentAlertCounter = 7
                this.getData()
                this.editModal = false
            })
        }
    },
    mounted() {
        this.errorMessage = 'Find Your Data'
        this.getDataPegawai()
    }
}
</script>
<style scoped>
.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 8px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 35px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: auto;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.nowraps {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.card-title {
    font-size: 14px;
    font-weight: 600;
    color: rgba(16, 16, 16, 1);
}
.card-subtitle {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
}
.card-emblem {
    float:right;
    background-color:rgba(48, 107, 221, 0.05);
    text-align: center;
    line-height: 32px;
    min-width:40px;
    min-height:40px;
    border-radius:50%;
}
input[type="checkbox"] {
    width: 16px;
    height: 16px;
    margin-right: 8px;
}
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
@media screen and (min-width: 1253px) and (max-width: 1358px) {
    .inputs-form {
        float:left;
        width:52%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1168px) and (max-width: 1252px) {
    .inputs-form {
        float:left;
        width:47%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1097px) and (max-width: 1167px) {
    .inputs-form {
        float:left;
        width:42%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1036px) and (max-width: 1096px) {
    .inputs-form {
        float:left;
        width:37%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 992px) and (max-width: 1035px) {
    .inputs-form {
        float:left;
        width:32%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1359px){
    .inputs-form {
        float:left;
        width:57%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
.btn-search {
    border-radius: 4px;
    float: right;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    float: right;
    width: 100%;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(360deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(0deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 24px;
    padding-right: 24px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 12px;
    padding-right: 24px;
    padding-left: 24px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}
.headers-modal {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(16, 16, 16, 1);
}
.modal-buttons {
    width:156px;
    height: 36px;
}
.modal-button-cancel {
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: white;
    color: rgba(16, 16, 16, 1);
}
.modal-button-cancel:hover {
    border: 1px solid rgba(48, 107, 240, 1);
    background-color: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.modal-button-simpan {
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.modal-button-simpan:hover {
    border: 1px solid rgba(48, 107, 240, 1);
    background-color: rgba(48, 107, 240, 1);
    color: white;
}

</style>